<template>
  <div class="w-full flex items-stretch">
    <quarter-picker
      class="flex-1"
      placeholder="费用隶属季度"
      v-model="quarter"
      clearable
      ref="quarterPicker"
      v-if="settleDateType === 'q'"
    />
    <el-date-picker
      v-model="month"
      type="month"
      size="small"
      class="flex-1"
      format="yyyy-MM"
      value-format="yyyy-MM"
      placeholder="费用隶属月份"
      clearable
      v-else
    />
    <el-dropdown @command="selectTypeHandle">
      <div
        class="w-10 h-full bg-theme-gray border-l border-solid border-white flex items-center justify-center"
      >
        <i class="el-icon-arrow-down text-medium text-d8"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="m">隶属月份</el-dropdown-item>
        <el-dropdown-item command="q">隶属季度</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import QuarterPicker from '@/components/base/QuarterPicker'

export default {
  name: 'SubjectionDateType',
  components: {
    QuarterPicker
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    value: {
      default: null
    },
    dateType: {
      type: String,
      default: 'm'
    }
  },
  data() {
    return {
      settleDateType: 'm',
      quarter: [],
      month: '',
    }
  },
  watch: {
    dateType() {
      this.setDateType();
    },
    value: {
      handler() {
        this.setDateValue();
      },
      deep: true,
    },
    quarter: {
      handler() {
        this.setValue();
      },
      deep: true,
    },
    month() {
      this.setValue();
    }
  },
  created() {
    this.setDateType();
    this.setDateValue();
  },
  methods: {
    setDateType() {
      if (this.settleDateType !== this.dateType) {
        this.settleDateType = this.dateType;
      }
    },
    setDateValue() {
      if (this.settleDateType === 'q') {
        const val = this.value ?? [];
        if (JSON.stringify(val) !== JSON.stringify(this.quarter)) {
          this.quarter = val;
        }
      } else {
        const val = this.value ?? '';
        if (val !== this.month) {
          this.month = val;
        }
      }
    },
    setValue() {
      if (this.settleDateType === 'q') {
        this.$emit('change', this.quarter);
      } else {
        this.$emit('change', this.month);
      }
    },
    selectTypeHandle(type) {
      this.settleDateType = type;
      this.$emit('update:dateType', type);
      this.setValue();
    },
    getQuarterFieldValue() {
      return this.$refs.quarterPicker?.quarterText ?? '';
    },
    reset() {
      this.quarter = [];
      this.month = '';
      this.settleDateType = 'm';
    }
  }
}
</script>